<template>
  <!-- no close-on-backdrop: the desktop icons fire tap + dblclick, so the second click would land here -->
  <div class="wallet-picker">
    <div class="wallet-picker-window">
      <h2>Choose A Wallet</h2>
      <button
        v-for="connector in connectors"
        :key="connector.uid"
        class="wallet-picker-option"
        @click="$emit('select', connector)"
      >
        <img
          v-if="connector.icon"
          :src="connector.icon"
          alt=""
        >
        {{ connector.id === 'injected' ? 'Browser Wallet' : connector.name }}
      </button>
      <button
        class="wallet-picker-cancel"
        @click="$emit('cancel')"
      >
        Cancel
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WalletPicker',
  props: {
    connectors: Array
  }
}
</script>

<style lang="scss" scoped>
.wallet-picker {
  position: fixed;
  inset: 0;
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
}

.wallet-picker-window {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 240px;
  padding: 16px;
  background: #ddd;
  border: 2px solid #000;
  box-shadow: 4px 4px 0 #000;
  font-size: 12px;
  color: #000;

  h2 {
    margin: 0 0 4px;
    font-size: 14px;
    text-align: center;
  }
}

.wallet-picker-option,
.wallet-picker-cancel {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 8px;
  background: #fff;
  border: 1px solid #000;
  font-size: 12px;
  text-align: left;
  cursor: pointer;

  &:hover {
    background: #000;
    color: #fff;
  }

  img {
    width: 20px;
    height: 20px;
  }
}

.wallet-picker-cancel {
  justify-content: center;
  background: #ccc;
}
</style>
